<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NK9ifD/tc-custom/9781639843237.jpg?1694763131988" alt="This image is the cover for the book Jewel of the Kingdom"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Jewel of the Kingdom
      </h1>
      <p class="bookDescription body article font2">
        <b>Amid an attempted assassination, the secrets of an ancient library, and looming climate disaster, China stands at a crossroads in this taut thriller.</b><br/>  <br/> Decades ago, an old woman in an Egyptian bookstore implemented a plan inspired by manuscripts rescued from the ancient Library of Alexandria. These papers predicted that when global climate change threatened humanity, opportunity would manifest—but to take advantage, China must awaken.<br/>  <br/> However, with the attempted murder of the Dalai Lama, someone is trying to return China to the old ways of Mao. How do the shocking similarities between quantum physics, Buddhism, and the ancient Japanese game of Go provide answers?<br/>  <br/> Only when the paths of a woman code-named The Blue Rose, sequestered in the Tiger Monastery of Bhutan, and the youngest high-ranking Chinese Communist known as The Seeker, converge will solutions become clear. While lovers embrace and assassins stalk their prey, the Middle Kingdom sits on a geopolitical precipice. One path leads to the old ways, the other to a new world . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Roy Dimond, Lorraine Dimond
      </h2>
      
      <p class="authorDescription body article">Roy and Lorraine Dimond currently reside in Victoria, the capital of British Columbia. Roy is the author of The Singing Bowl, The Rubicon Effect, Silence and Circumstance, A Penny for Your Thoughts, and Rendezvous at Carchemish. In his first life, he had the honor of helping at risk children and their families. After years of being Roy's first round editor, when Lorraine retired from teaching and counselling, she joined Roy to collaborate on The Jewel of the Kingdom. Connect with Roy and Lorraine: roydimond.tripod.com roydimond.wordpress.com twitter.com/RoyDimond2 www.authorsden.com/roydimond www.facebook.com/pages/Roy-Dimond-Author/391172050979499 www.linkedin.com/in/roy-dimond-414b4534 www.goodreads.com/author/show/5027782.Roy_Dimond dimondsquared@gmail.com dimond.lor@gmail.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6a856d7c